import { makeStyles } from "tss-react/mui";
import { Box, Tooltip } from "@mui/material";
import { COLUMN_WIDTH } from "./chartView.constants";
import { TriggerNodeData } from "./chartView.types";

export const TriggerNode = ({ data }: { data: TriggerNodeData }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.card}>
      <Box className={classes.titleRow}>
        {data.labels.map((label, i) => (
          <Box
            key={`chart-label-${i}`}
            className={classes.chip}
            style={{
              backgroundColor: label.color,
              color: label.labelColor,
            }}
          >
            {label.dependencyLabel}.
          </Box>
        ))}
        <Tooltip title={data.title} placement="top" arrow>
          <Box className={classes.title}>{data.title}</Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  card: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.grey.lightAccent}`,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3, 2),
    boxShadow: "0px 1px 2px 0px #0000000F",
    fontWeight: theme.fontWeight.semiBold,
    fontSize: theme.fontSize.small,
    width: COLUMN_WIDTH,
    boxSizing: "border-box",
    wordBreak: "break-word",
  },
  titleRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "nowrap",
    gap: theme.spacing(0.5),
    overflow: "hidden",
  },
  title: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  chip: {
    padding: theme.spacing(1, 1.5),
    fontWeight: theme.fontWeight.semiBold,
    borderRadius: theme.spacing(0.75),
    fontSize: theme.fontSize.xsmall,
    whiteSpace: "nowrap",
  },
}));
